module.exports = {"notification.message":"Wix.com uses cookies to give you the best possible experience.","notification.more.info":"Read More","notification.got.it":"Got It","notification.got.it.arrow":"arrow icon"}


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_en.json
// module id = 46
// module chunks = 0